module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-bar"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/admin/dashboard"
    }
  }, [_vm._v(_vm._s((_vm.user.organizations[0] == null) ? 'CaseMGR' : _vm.user.organizations[0].name))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })], 1), _vm._v(" "), _vm._l((_vm.crumbs), function(crumb, index) {
    return _c('li', [(typeof crumb == 'object' && crumb.link != null) ? _c('router-link', {
      attrs: {
        "to": {
          name: crumb.link,
          params: {
            id: crumb.id
          }
        },
        "tag": "span"
      }
    }, [_c('a', {
      staticClass: "crumb"
    }, [_vm._v(_vm._s(crumb.name))])]) : (crumb.url != null) ? _c('a', {
      staticClass: "crumb",
      attrs: {
        "href": crumb.url
      }
    }, [_vm._v(_vm._s(crumb.name))]) : _c('span', [_vm._v(_vm._s((typeof crumb == 'object') ? crumb.name : crumb))]), _vm._v(" "), (_vm.crumbs.length > ++index) ? _c('i', {
      staticClass: "fa fa-angle-right"
    }) : _vm._e()], 1)
  })], 2), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e61533de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Breadcrumbs.vue
// module id = 1749
// module chunks = 1